export default __webpack_public_path__ + "static/media/silver2.71eb4675.png";